// ============================================================
// KIN HAKAN — SINGLE SOURCE OF CONTENT
// Edit file ini untuk meng-update SELURUH isi website.
//
// Cara mengganti foto / video:
//   ganti  src: null  menjadi  src: "URL-atau-path-gambar"
//   contoh: src: "https://..." atau src: "/images/foto-01.jpg"
// Slot yang masih null akan tampil sebagai placeholder "ADD YOUR PHOTO".
//
// JANGAN mengubah nama key — cukup ganti value-nya.
// ============================================================

import { M, V } from "./media";

export const LINKS = {
  instagram: "https://www.instagram.com/kinhakann/",
  email: "h4k4n.gobel02@gmail.com",
};

export const PROFILE = {
  name: "KIN HAKAN AZRIEL GOBEL",
  shortName: "KIN HAKAN",
  tagline: "Creator. Communicator. Changemaker.",
  location: "Tangerang Selatan, Indonesia",
  heroImage: "/media/duta/img-24.webp", // HERO_PROFILE_IMAGE — Duta Lalu Lintas Mandala Jaya 2025
  // ABOUT_PORTRAIT_IMAGE — foto di halaman About
  aboutPortrait: "/media/ycws/img-16.webp",
  // SPEAKING_IMAGE — foto Kin saat di panggung
  speakingImage: "/media/osis/img-09.webp",
};

export const HERO = {
  lines: ["CREATOR.", "COMMUNICATOR.", "CHANGEMAKER."],
  intro: "I'M KIN — I CREATE. I CONNECT. I CONTRIBUTE.",
  handwritten: "still figuring things out. still making things happen.",
  copy: "Dari membuat konten, memimpin organisasi, berbicara di depan audiens, sampai terlibat dalam berbagai gerakan kepemudaan — saya terus mengeksplorasi cara untuk menciptakan sesuatu yang berarti.",
  marquee: ["CONTENT CREATOR", "PUBLIC SPEAKER", "YOUTH LEADER", "STORYTELLER", "CREATIVE"],
};

export const STICKERS = [
  { icon: "MapPin", label: "TANGERANG SELATAN", x: "6%", y: "22%", rot: "-6deg", color: "ink" },
  { icon: "Video", label: "CONTENT CREATOR", x: "72%", y: "18%", rot: "5deg", color: "ember" },
  { icon: "Mic", label: "PUBLIC SPEAKER", x: "80%", y: "58%", rot: "-4deg", color: "burgundy" },
  { icon: "Sprout", label: "YOUTH MOVEMENT", x: "4%", y: "66%", rot: "4deg", color: "paper" },
  { icon: "TrafficCone", label: "DUTA LALU LINTAS", x: "60%", y: "82%", rot: "3deg", color: "ink" },
];

export const MANIFESTO = {
  label: "MORE THAN A TITLE.",
  lines: [
    "Organisasi mengajarkan saya untuk memimpin.",
    "Panggung mengajarkan saya untuk berbicara.",
    "PIK-R mengajarkan saya untuk mendengar.",
    "Content creation mengajarkan saya untuk bercerita.",
  ],
  closing: "Dan setiap kesempatan membuat saya semakin memahami satu hal: saya ingin menggunakan apa yang saya punya untuk memberi pengaruh positif.",
};

export const IDENTITIES = [
  { no: "01", key: "CREATE", title: "CREATE", desc: "Content creation, video editing, photography, visual storytelling.", to: "/creative" },
  { no: "02", key: "COMMUNICATE", title: "COMMUNICATE", desc: "Public speaking, MC, social media, media & communication.", to: "/impact" },
  { no: "03", key: "LEAD", title: "LEAD", desc: "Organizational leadership, PIK-R, OSIS, Paskibra, youth communities.", to: "/experiences" },
  { no: "04", key: "IMPACT", title: "IMPACT", desc: "Youth empowerment, volunteering, education, anti-bullying, GenRe, SDGs, environmental initiatives.", to: "/impact" },
];

export const UNIVERSE = [
  { word: "CREATE", to: "/creative", note: "video / photo / design" },
  { word: "CONNECT", to: "/experiences", note: "communities & people" },
  { word: "SPEAK", to: "/impact", note: "stage / MC / forums" },
  { word: "LEAD", to: "/experiences", note: "organizations" },
  { word: "IMPACT", to: "/impact", note: "youth & social" },
  { word: "EXPLORE", to: "/journal", note: "stories & reflections" },
];

export const CHAPTERS = [
  { no: "01", title: "THE CURIOUS KID", text: "Sedari kecil, selalu punya rasa ingin tahu yang besar dan senang tampil." },
  { no: "02", title: "THE DIGITAL EXPLORER", text: "Masa pandemi membuka pintu ke dunia digital — layar menjadi ruang belajar pertama." },
  { no: "03", title: "THE STUDENT", text: "Fokus pada akademik, lulus sebagai salah satu siswa terbaik di SMP." },
  { no: "04", title: "THE ORGANIZER", text: "OSIS, Paskibra — belajar bahwa leadership tidak selalu berdiri paling depan." },
  { no: "05", title: "THE CREATOR", text: "Internet menjadi kelas pertama untuk kreativitas: konten, edit, cerita." },
  { no: "06", title: "THE YOUTH ADVOCATE", text: "PIK-R, GenRe, PAB, SDGs — ruang-ruang untuk mendengar dan berkontribusi." },
  { no: "07", title: "THE LEADER", text: "Dari peserta menjadi ketua, dari penonton menjadi pembawa pesan." },
  { no: "08", title: "WHAT'S NEXT?", text: "Perjalanan belum selesai. Justru, ini baru mulai." },
];

export const STATS = [
  { value: "2×", label: "OSIS Secretary", sub: "dua periode berturut" },
  { value: "#1", label: "Academic Rank", sub: "dipertahankan dari kelas 10–12 (in progress)" },
  { value: "1st", label: "Generation of active PIK-R SMILEIO", sub: "mengaktifkan kembali PIK-R sekolah" },
  { value: "2025", label: "Duta Lalu Lintas", sub: "Polres Tangerang Selatan" },
  { value: "1×", label: "Best Cultural Ambassador", sub: "Pelajar SDGs Batch 4" },
  { value: "1×", label: "Anggota Terkreatif Putra", sub: "PAB Banten" },
];

// ------------------------------------------------------------
// EXPERIENCES
// Media asli dari Google Drive — dikelola lewat media.js (M/V).
// ------------------------------------------------------------
export const EXPERIENCES = [
  {
    slug: "pikr-smileio",
    featured: true,
    no: "01",
    title: "PIK-R SMILEIO",
    org: "SMAN 10 Kota Tangerang Selatan",
    role: "Chairperson",
    year: null, // ADD YEAR
    tags: ["YOUTH", "LEADERSHIP", "PEER COUNSELING"],
    hook: "I didn't just join a PIK-R. I helped bring one back to life.",
    story: "PIK-R SMILEIO menjadi salah satu bagian terpenting dalam perjalanan kepemudaan saya. Saya menjabat sebagai Chairperson dan menjadi bagian dari generasi pertama yang aktif mengembangkan kembali PIK-R sekolah yang sebelumnya tidak berjalan aktif.",
    did: [
      "Mengaktifkan kembali PIK-R yang sebelumnya tidak aktif",
      "Mengembangkan kegiatan dan program PIK-R di sekolah",
      "Membangun komunikasi yang dekat dengan keseharian remaja",
      "Membuat konten edukasi di media sosial",
      "Mengembangkan peer counseling melalui SMILE TALK",
    ],
    learned: "Mendengarkan ternyata bisa menjadi sebuah aksi. Ruang yang terasa aman dan dekat bisa lahir dari hal sederhana — termasuk dari media sosial.",
    takeaway: "Leadership bukan tentang jabatan. Kadang, leadership adalah menghidupkan kembali sesuatu yang sempat berhenti.",
    mission: "PIK-R di sekolah kami sempat tidak aktif. Daripada menunggu orang lain menghidupkannya, kami memutuskan untuk memulai sendiri — karena remaja butuh ruang cerita yang dekat, bukan yang jauh dan formal.",
    reflection: "Ternyata menghidupkan sesuatu yang sempat berhenti jauh lebih menantang daripada sekadar bergabung — dan justru di situlah serunya.",
    images: M("smileio", [1, 4, 5, 11, 13, 14, 15, 16, 17, 18, 19, 20], {
      1: "Peer counseling — PIK-R SMILEIO",
      5: "Sesi bercerita bersama peer counselor",
      11: "Tim PIK-R SMILEIO",
      13: "PIK-R SMILEIO bersama guru pembina",
    }),
    videos: V("smileio", 5, { 1: "SMILE TALK — PIK-R SMILEIO" }),
    caseStudy: true,
  },
  {
    slug: "duta-lalu-lintas",
    featured: true,
    no: "02",
    title: "DUTA LALU LINTAS 2025",
    org: "Polres Tangerang Selatan",
    role: "Duta Lalu Lintas",
    year: "2025",
    extra: "Finalist — Duta Lalu Lintas Mandala Jaya 2025",
    tags: ["PUBLIC SPEAKING", "SOCIAL CAMPAIGN", "REPRESENTATION"],
    hook: "Membawa sebuah isu menjadi lebih mudah dipahami banyak orang.",
    story: "Pengalaman ini mempertemukan saya dengan dunia public communication secara lebih langsung — bagaimana menyampaikan pesan kepada masyarakat, tampil di depan publik, dan membawa sebuah isu menjadi lebih mudah dipahami.",
    did: [
      "Mengikuti rangkaian seleksi Duta Lalu Lintas Tangerang Selatan 2025",
      "Terlibat dalam kampanye dan sosialisasi kepada masyarakat",
      "Tampil berbicara di depan publik dalam berbagai kegiatan resmi",
      "Menjadi Finalis Duta Lalu Lintas Mandala Jaya 2025",
    ],
    learned: "Pesan yang baik tidak hanya didengar — tapi dipahami dan diingat.",
    takeaway: "Representasi adalah tanggung jawab: kamu membawa nama yang lebih besar dari dirimu sendiri.",
    mission: "Lalu lintas bukan isu yang seksi buat anak muda — justru karena itu pesannya perlu dibawakan dengan cara yang lebih dekat.",
    reflection: "Di sini saya belajar bahwa public communication bukan tentang siapa yang paling keras bersuara, tapi siapa yang paling bisa didengar.",
    images: M("duta", 28, {
      3: "Duta Lalu Lintas — Satlantas Polres Tangsel",
      13: "Kegiatan Duta Lalu Lintas Tangsel 2025",
      17: "Operasi Zebra Jaya 2025 — Ditlantas Polda Metro Jaya",
      24: "Duta Lalu Lintas Mandala Jaya 2025",
      28: "Sertifikat — Duta Lalu Lintas 2025",
    }),
    videos: V("duta", 9, { 1: "Liputan tvOne — Apel Saka Bhayangkara, Polda Metro Jaya", 2: "Konten sosial media — Duta Lalu Lintas" }),
  },
  {
    slug: "osis",
    no: "03",
    title: "OSIS SMAN 10",
    org: "SMAN 10 Kota Tangerang Selatan",
    role: "Secretary — 2 Periods",
    year: null,
    tags: ["LEADERSHIP", "ADMINISTRATION", "EVENTS"],
    hook: "Leadership tidak selalu berarti berdiri paling depan.",
    story: "Dua periode sebagai sekretaris membuat saya belajar bahwa leadership tidak selalu berarti berdiri paling depan. Kadang, leadership berarti memastikan semuanya tetap berjalan.",
    did: [
      "Mengelola administrasi organisasi selama dua periode",
      "Koordinasi antar-bidang dan persiapan event sekolah",
      "Manajemen organisasi dan dokumentasi kegiatan",
      "Menjadi MC di berbagai acara sekolah",
    ],
    learned: "Hal-hal yang tidak terlihat sering justru yang paling menentukan berjalan atau tidaknya sesuatu.",
    takeaway: "Sistem yang rapi adalah bentuk kepedulian kepada tim.",
    reflection: "Dua periode di posisi yang sama mengajarkan hal berbeda: periode pertama belajar sistemnya, periode kedua memperbaikinya.",
    images: M("osis", 12, { 9: "MC — kegiatan sekolah" }),
    videos: V("osis", 2),
  },
  {
    slug: "paskibra",
    no: "04",
    title: "PASKIBRA SMAN 10",
    org: "SMAN 10 Kota Tangerang Selatan",
    role: "Secretary",
    year: null,
    tags: ["DISCIPLINE", "COORDINATION"],
    hook: "Disiplin adalah bahasa tanpa kata.",
    story: "Di Paskibra, saya belajar bahwa presisi dan tanggung jawab bukan sekadar aturan — melainkan cara menghargai tim dan waktu.",
    did: [
      "Administrasi dan koordinasi internal Paskibra",
      "Menjaga kedisiplinan dan keteraturan organisasi",
      "Bertanggung jawab atas dokumentasi kegiatan",
    ],
    learned: "Ketepatan kecil yang dijaga setiap hari membentuk kepercayaan yang besar.",
    takeaway: "Tanggung jawab dimulai dari hal yang paling sederhana.",
    images: M("paskibra", 4, { 4: "Kompetisi Paskibra — SMAN 10 Tangsel" }),
    videos: [],
  },
  {
    slug: "forum-genre",
    no: "05",
    title: "FORUM GENRE CIPUTAT",
    org: "Forum GenRe Kecamatan Ciputat",
    role: "Media & Communication",
    year: null,
    tags: ["GENRE", "MEDIA", "YOUTH"],
    hook: "Satu bab dalam perjalanan gerakan kepemudaan yang lebih besar.",
    story: "GenRe adalah salah satu ruang di mana saya belajar bagaimana isu-isu remaja bisa dikomunikasikan dengan cara yang dekat dan relevan — bukan menggurui, tapi mengajak bicara.",
    did: [
      "Mengelola media dan komunikasi Forum GenRe Kecamatan Ciputat",
      "Membuat konten edukasi GenRe untuk remaja",
      "Terlibat dalam kegiatan youth engagement",
    ],
    learned: "Isu yang berat bisa terasa ringan ketika disampaikan dengan bahasa yang tepat.",
    takeaway: "Media adalah jembatan — bukan sekadar panggung.",
    reflection: "Isu remaja tidak butuh bahasa yang berat — ia butuh pembawa pesan yang mau mendengar dulu sebelum bicara.",
    images: M("smileio", [7, 8, 9, 10, 12, 22], {
      7: "Dokumentasi PIK-R SMILEIO & Forum GenRe Ciputat",
      22: "Apresiasi partner — bukber Forum GenRe Ciputat",
    }),
    videos: [],
  },
  {
    slug: "pab-community",
    no: "06",
    title: "PAB COMMUNITY — BATCH 5",
    org: "Pelajar Anti Bullying (PAB) Community",
    role: "Content Creator Division",
    year: null,
    extra: "Anggota Terkreatif Putra — PAB Banten",
    tags: ["ANTI-BULLYING", "CONTENT", "CREATIVE"],
    hook: "Menggunakan kreativitas untuk ruang yang lebih aman bagi pelajar.",
    story: "Di PAB, saya menggunakan kreativitas dan media untuk menyampaikan pesan tentang lingkungan yang lebih aman bagi pelajar — dan ikut mengorganisir sebuah webinar sebagai bagian dari misi itu.",
    did: [
      "Membuat konten kampanye anti-bullying",
      "Menjadi bagian tim penyelenggara webinar PAB",
      "Berkolaborasi dengan relawan pelajar dari berbagai daerah",
    ],
    learned: "Kreativitas punya kekuatan untuk menyentuh isu yang serius tanpa kehilangan empati.",
    takeaway: "Konten yang baik bisa membuat seseorang merasa tidak sendirian.",
    award: "Anggota Terkreatif Putra — PAB Banten",
    mission: "Bullying sering dianggap 'candaan biasa'. Lewat konten, saya ingin membuat topik ini terasa dekat dan bisa dibicarakan siapa pun.",
    reflection: "Award 'Terkreatif' itu menyenangkan, tapi yang lebih membekas adalah saat konten yang kami buat membuat orang berani cerita.",
    images: M("pab", 8, {
      1: "Pembekalan PAB Community Batch 5",
      2: "Anggota Terkreatif Putra — PAB Community Batch 5",
      5: "Webinar 'Apakabar Mentalmu' — Moderator",
      6: "Livestreaming Mental Health — Speaker",
    }),
    videos: V("pab", 4, { 1: "Konten PAB Community", 3: "Sesi PAB Community Batch 5" }),
  },
  {
    slug: "pelajar-sdgs",
    no: "07",
    title: "FORUM PELAJAR SDGS",
    org: "Forum Pelajar SDGs",
    role: "Batch 4: Participant → Batch 5: External Committee",
    year: null,
    extra: "Best Cultural Ambassador — Batch 4",
    tags: ["SDGS", "LEADERSHIP", "GLOBAL GOALS"],
    hook: "Dari peserta menjadi bagian dari kepanitiaan.",
    story: "Ruang untuk belajar tentang tujuan global menjadi ruang untuk memahami bagaimana anak muda bisa berkontribusi secara lokal. Di Batch 4 saya belajar sebagai peserta; di Batch 5 saya kembali sebagai External Committee.",
    did: [
      "Mengikuti Forum Pelajar SDGs Batch 4 dan terpilih sebagai Best Cultural Ambassador",
      "Kembali di Batch 5 sebagai External Committee",
      "Terlibat dalam diskusi dan aksi seputar SDGs",
    ],
    learned: "LEARN → PARTICIPATE → CONTRIBUTE. Kontribusi terbaik sering dimulai dari kesediaan untuk belajar dulu.",
    takeaway: "Isu global selalu punya wajah lokal.",
    award: "Best Cultural Ambassador — Batch 4",
    mission: "Tujuan global terasa jauh sampai kamu menyadari bahwa semuanya punya versi lokalnya — dan anak muda bisa mulai dari situ.",
    reflection: "Kembali sebagai panitia setelah jadi peserta itu rasanya beda: kamu berhenti bertanya 'apa yang bisa kudapat' dan mulai bertanya 'apa yang bisa kuberi'.",
    images: M("sdgs", 16, {
      2: "Open recruitment — Batch V",
      10: "Best SDGs Cultural Ambassador — Batch IV",
      16: "Dokumentasi Instagram",
    }),
    videos: V("sdgs", 7, { 1: "Recap — Forum Pelajar SDGs" }),
  },
  {
    slug: "youcanweshare",
    no: "08",
    title: "YOUCANWESHARE",
    org: "YouCanWeShare",
    role: "Volunteer",
    year: null,
    tags: ["VOLUNTEERING", "COMMUNITY"],
    hook: "Hadir, dan benar-benar hadir.",
    story: "Menjadi volunteer mengajarkan saya satu hal sederhana: kehadiran yang tulus sering kali lebih berarti daripada apa pun. Termasuk saat mengunjungi dan menghabiskan waktu bersama anak-anak di panti asuhan.",
    did: [
      "Terlibat sebagai volunteer dalam kegiatan sosial",
      "Mengunjungi dan berbagi waktu dengan anak-anak panti asuhan",
    ],
    learned: "Empati bukan teori — ia dilatih lewat pertemuan yang nyata.",
    takeaway: "Memberi tidak selalu soal barang. Kadang cukup soal waktu.",
    reflection: "Anak-anak di panti itu tidak butuh kita jadi siapa-siapa. Mereka cuma butuh kita benar-benar ada di sana.",
    images: M("ycws", 20, {
      1: "Bakti sosial — Juni 2026",
      2: "Kunjungan panti asuhan — Sahabat Yatim",
      16: "Apresiasi relawan — YouCanWeShare",
    }, [3, 10]),
    videos: V("ycws", 4, { 3: "Bakti sosial bersama Sahabat Yatim" }),
  },
  {
    slug: "envirocrime",
    no: "09",
    title: "ENVIROCRIME DIALOGUE",
    org: "Universitas Budi Luhur",
    role: "Participant — FGD & Debate",
    year: null,
    tags: ["ENVIRONMENT", "DEBATE", "CRITICAL THINKING"],
    hook: "Berdebat untuk memahami, bukan untuk menang.",
    story: "Envirocrime Dialogue mempertemukan saya dengan diskusi isu lingkungan dalam format Focus Group Discussion dan debat — ruang di mana opini harus berdiri di atas argumen.",
    did: [
      "Berpartisipasi dalam Focus Group Discussion isu lingkungan",
      "Mengikuti sesi debat seputar envirocrime",
      "Berdiskusi dengan peserta dari berbagai latar belakang",
    ],
    learned: "Berpikir kritis dan berbicara di depan umum adalah dua otot yang bisa dilatih bersamaan.",
    takeaway: "Isu lingkungan bukan isu pinggiran — ia menyangkut masa depan kita sendiri.",
    images: M("envirocrime", 8, { 1: "Envirocrime Dialogue — Universitas Budi Luhur" }),
    videos: [],
  },
  {
    slug: "forest-forum",
    no: "10",
    title: "NATIONAL FOREST LEADERSHIP FORUM",
    org: "Kementerian Lingkungan Hidup dan Kehutanan",
    role: "Participant",
    year: null,
    tags: ["LEADERSHIP", "ENVIRONMENT", "COLLABORATION"],
    hook: "Kepemimpinan yang berakar pada isu nyata.",
    story: "Forum kepemimpinan pemuda tingkat nasional ini membuka perspektif baru tentang isu kehutanan dan lingkungan — dan bagaimana kolaborasi anak muda bisa menjadi bagian dari solusinya.",
    did: [
      "Berpartisipasi dalam forum kepemimpinan pemuda nasional",
      "Mengikuti kegiatan di lingkungan Kementerian Lingkungan Hidup dan Kehutanan",
      "Berjejaring dengan pemuda dari berbagai daerah",
    ],
    learned: "Skala sebuah isu tidak pernah jadi alasan untuk tidak mulai bergerak.",
    takeaway: "Kolaborasi adalah bentuk kepemimpinan yang paling nyata.",
    reflection: "Berdiri di gedung kementerian membahas hutan membuat isu lingkungan terasa bukan lagi konten — melainkan pekerjaan rumah generasi kami.",
    images: M("forest", 32, {
      1: "Kampanye isu kehutanan",
      5: "Sesi forum — Kementerian LHK",
      10: "Best Team — National Forest Leadership Forum",
      32: "Sertifikat — National Forest Leadership Forum",
    }),
    videos: V("forest", 2, { 1: "Sesi National Forest Leadership Forum" }),
  },
  {
    slug: "jawara-demokrasi",
    no: "11",
    title: "SEKOLAH JAWARA DEMOKRASI",
    org: "KPU Kota Tangerang Selatan",
    role: "Participant",
    year: null,
    tags: ["DEMOCRACY", "YOUTH", "CIVIC EDUCATION"],
    hook: "Belajar demokrasi langsung dari penyelenggaranya.",
    story: "Selama tiga hari saya mengikuti Sosialisasi Pendidikan Pemilih bersama KPU Kota Tangerang Selatan — sebuah perjalanan untuk memahami bagaimana demokrasi bekerja dan mengapa suara anak muda penting.",
    did: [
      "Mengikuti rangkaian Sosialisasi Pendidikan Pemilih selama tiga hari",
      "Berdiskusi tentang peran pemilih muda dalam demokrasi",
      "Berjejaring dengan peserta dari berbagai sekolah dan komunitas",
    ],
    learned: "Demokrasi bukan acara lima tahunan — ia kebiasaan yang dibangun sejak muda.",
    takeaway: "Suara kecil hari ini, perubahan besar nanti.",
    mission: "Pemilih muda sering dicap apatis. Saya ingin membuktikan sebaliknya — dimulai dari kesediaan untuk belajar dulu.",
    reflection: "Tiga hari yang membuat saya melihat pemilu bukan sebagai formalitas, melainkan hak yang punya konsekuensi.",
    images: M("jawara", 7, {
      2: "Sekolah Jawara Demokrasi — KPU Tangsel",
      3: "Sosialisasi Pendidikan Pemilih (3 hari)",
    }),
    videos: [],
  },
  {
    slug: "metro-tv",
    no: "12",
    title: "METRO TV STUDIO VISIT",
    org: "Metro TV — Media Group Network",
    role: "Participant",
    year: "2026",
    tags: ["MEDIA", "BROADCAST", "COMMUNICATION"],
    hook: "Melihat langsung bagaimana berita diproduksi — dari newsroom sampai on-air.",
    story: "Sebagai seseorang yang tertarik pada media dan komunikasi, mengunjungi studio Metro TV menjadi kesempatan untuk melihat dari dekat bagaimana konten berita diproduksi secara profesional.",
    did: [
      "Mengunjungi studio dan newsroom Metro TV, Media Group Network",
      "Melihat proses produksi siaran dari balik layar",
      "Mempelajari alur kerja jurnalistik televisi",
    ],
    learned: "Di balik tayangan beberapa menit, ada tim besar dan disiplin produksi yang presisi.",
    takeaway: "Media yang baik dibangun dari proses yang serius.",
    reflection: "Kunjungan ini memperkuat ketertarikan saya pada dunia media dan komunikasi.",
    images: M("metrotv", 9, {
      1: "Media Group Network — 24 Juni 2026",
      9: "Dokumentasi kunjungan — Instagram",
    }),
    videos: V("metrotv", 6, { 1: "Di dalam studio Metro TV" }),
  },
];

export const SMILE_TALK = {
  title: "SMILE TALK",
  subtitle: "Counseling should feel closer.",
  description: "Sebuah inisiatif peer counseling dari PIK-R SMILEIO yang berinovasi dalam counselor booking melalui media sosial — membuat ruang bercerita terasa lebih dekat dengan keseharian remaja.",
  flow: [
    { step: "01", label: "A TEEN NEEDS SOMEONE TO TALK TO", desc: "Remaja membutuhkan ruang yang terasa dekat dan nyaman untuk bercerita." },
    { step: "02", label: "PIK-R CREATES A SPACE", desc: "PIK-R SMILEIO menghadirkan peer counseling sebagai ruang aman." },
    { step: "03", label: "SOCIAL MEDIA BECOMES THE BRIDGE", desc: "Membuat akses peer counseling lebih familiar dengan memanfaatkan media sosial." },
    { step: "04", label: "COUNSELOR BOOKING", desc: "Counselor booking dilakukan langsung melalui social media." },
    { step: "05", label: "PEER CONNECTION", desc: "Membawa fungsi PIK-R lebih dekat dengan keseharian remaja." },
  ],
  gallery: M("smileio", [21, 23, 24, 25, 1, 5], {
    21: "Ketua PIK-R — konten pengumuman",
    1: "Peer counseling — PIK-R SMILEIO",
    5: "Sesi bercerita bersama peer counselor",
    25: "@pikrsmileio di Instagram",
  }),
};

// ------------------------------------------------------------
// CREATIVE STUDIO
// ------------------------------------------------------------
export const CREATIVE_INTRO = {
  title: "I LIKE TO MAKE THINGS.",
  copy: "Bagi saya, content creation bukan cuma soal membuat sesuatu terlihat bagus. Ini tentang bagaimana sebuah ide bisa terasa, dipahami, dan akhirnya sampai kepada orang lain.",
  pillars: [
    { key: "VIDEO", desc: "Video editing, short-form content, storytelling, social media videos." },
    { key: "PHOTO", desc: "Photo editing, visual composition, creative photography." },
    { key: "DESIGN", desc: "Canva, social media graphics, campaign visuals." },
    { key: "STORYTELLING", desc: "Turning ideas into content." },
  ],
};

// Portfolio projects — ganti src dengan thumbnail asli, lengkapi fieldnya.
export const PROJECTS = [
  { id: "p1", title: "Ketua PIK-R", category: "DESIGN", desc: "Desain pengumuman — PIK-R SMILEIO", year: "2026", tools: "Canva", src: "/media/smileio/img-21.webp", url: null },
  { id: "p2", title: "Apakabar Mentalmu", category: "CAMPAIGN", desc: "Visual webinar PAB Community Batch 5", year: "2026", tools: "Canva", src: "/media/pab/img-05.webp", url: null },
  { id: "p3", title: "Mental Health Livestream", category: "SOCIAL MEDIA", desc: "Konten livestreaming PAB Community", year: "2026", tools: "Canva", src: "/media/pab/img-06.webp", url: null },
  { id: "p4", title: "Pelajar SDGs Batch V", category: "CAMPAIGN", desc: "Visual open recruitment Forum Pelajar SDGs", year: "2026", tools: "Canva", src: "/media/sdgs/img-02.webp", url: null },
  { id: "p5", title: "Forests Are Disappearing", category: "DESIGN", desc: "Kampanye isu kehutanan — National Forest Leadership Forum", year: "2026", tools: "Canva", src: "/media/forest/img-01.webp", url: null },
  { id: "p6", title: "#KincredibleJourney", category: "PERSONAL", desc: "Dokumentasi Sekolah Jawara Demokrasi KPU", year: null, tools: "Canva / CapCut", src: "/media/jawara/img-07.webp", url: null },
];

// MOVING STORIES — video portfolio. src: thumbnail, videoSrc: file/embed video.
export const VIDEOS = [
  { id: "v1", title: "Recap — Forum Pelajar SDGs", desc: "Dari peserta Batch 4 sampai External Committee Batch 5", tools: "CapCut", year: "2026", src: "/media/sdgs/vid-01.jpg", videoSrc: "/media/sdgs/vid-01.mp4", url: null },
  { id: "v2", title: "SMILE TALK — PIK-R SMILEIO", desc: "Peer counseling yang lebih dekat lewat social media", tools: "CapCut", year: "2026", src: "/media/smileio/vid-03.jpg", videoSrc: "/media/smileio/vid-03.mp4", url: null },
  { id: "v3", title: "Duta Lalu Lintas 2025", desc: "Dokumentasi perjalanan Duta Lalu Lintas Tangsel", tools: "CapCut", year: "2025", src: "/media/duta/vid-01.jpg", videoSrc: "/media/duta/vid-01.mp4", url: null },
];

// @KINHAKANN — Instagram showcase. Isi dengan konten pilihan.
export const INSTAGRAM = {
  handle: "@kinhakann",
  sub: "The internet was one of my first classrooms. Now it's one of the places where I tell stories.",
  posts: [
    { id: "ig1", kind: "FEATURED POST", src: "/media/pab/img-02.webp", caption: "Found my mission — Anggota Terkreatif Putra, PAB Community Batch 5", url: null, stats: null },
    { id: "ig2", kind: "FEATURED REEL", src: "/media/sdgs/vid-01.jpg", videoSrc: "/media/sdgs/vid-01.mp4", caption: "Recap — Forum Pelajar SDGs", url: null, stats: null },
    { id: "ig3", kind: "FEATURED REEL", src: "/media/osis/vid-01.jpg", videoSrc: "/media/osis/vid-01.mp4", caption: "OSIS SMAN 10 Tangsel", url: null, stats: null },
    { id: "ig4", kind: "FEATURED POST", src: "/media/sdgs/img-10.webp", caption: "Best SDGs Cultural Ambassador — Batch IV", url: null, stats: null },
    { id: "ig5", kind: "FEATURED POST", src: "/media/jawara/img-07.webp", caption: "#KincredibleJourney — Sekolah Jawara Demokrasi KPU", url: null, stats: null },
    { id: "ig6", kind: "FEATURED CONTENT", src: "/media/metrotv/img-09.webp", caption: "Studio visit — Metro TV", url: null, stats: null },
  ],
};

// ------------------------------------------------------------
// IMPACT
// ------------------------------------------------------------
export const IMPACT_AREAS = [
  { key: "YOUTH", desc: "PIK-R, GenRe, PAB, SDGs", items: ["PIK-R SMILEIO", "Forum GenRe Ciputat", "PAB Community", "Forum Pelajar SDGs", "Sekolah Jawara Demokrasi (KPU)"] },
  { key: "EDUCATION", desc: "academic achievement & educational content", items: ["Academic Rank #1 (Grade 10–12, in progress)", "Konten edukasi PIK-R & GenRe"] },
  { key: "COMMUNITY", desc: "volunteering & youth organizations", items: ["YouCanWeShare", "OSIS SMAN 10", "Paskibra SMAN 10"] },
  { key: "COMMUNICATION", desc: "public speaking, MC, social media, campaigns", items: ["Duta Lalu Lintas 2025", "MC acara sekolah", "SMILE TALK", "Kunjungan Studio Metro TV"] },
  { key: "ENVIRONMENT", desc: "environmental awareness", items: ["Envirocrime Dialogue", "National Forest Leadership Forum", "Pelajar SDGs"] },
];

export const IMPACT_QUOTE = "Saya mungkin masih dalam proses belajar, tetapi saya ingin setiap ruang yang saya masuki menghasilkan sesuatu yang lebih baik.";

export const TOPICS = [
  "Youth Development", "GenRe", "Peer Counseling", "Mental Wellbeing",
  "Anti-Bullying", "Leadership", "Education", "Digital Creativity",
  "Content Creation", "Environmental Awareness", "Social Participation", "Youth Empowerment",
];

export const SPEAKING = {
  title: "PUT ME ON A STAGE.",
  copy: "Saya selalu menikmati momen ketika sebuah pesan harus disampaikan kepada banyak orang.",
  quote: "A good message isn't only heard. It is remembered.",
  items: ["MC", "Public Speaking", "Sosialisasi", "Youth Forums", "Debate", "FGD", "Campaigns", "Organizational Events"],
  gallery: [
    { src: "/media/osis/img-09.webp", caption: "MC — kegiatan sekolah", slot: "SPEAKING_IMAGE_01" },
    { src: "/media/duta/img-03.webp", caption: "Duta Lalu Lintas Tangsel 2025", slot: "SPEAKING_IMAGE_02" },
    { src: "/media/jawara/img-07.webp", caption: "Sekolah Jawara Demokrasi — KPU Tangsel", slot: "SPEAKING_IMAGE_03" },
    { src: "/media/forest/img-04.webp", caption: "National Forest Leadership Forum — KLHK", slot: "SPEAKING_IMAGE_04" },
    { src: "/media/sdgs/img-08.webp", caption: "Forum Pelajar SDGs", slot: "SPEAKING_IMAGE_05" },
  ],
};

export const VISION = {
  title: "WHERE I WANT TO GO",
  paragraphs: [
    "Saya ingin menjadi seseorang yang tidak hanya dikenal karena apa yang saya capai, tetapi karena apa yang saya tinggalkan.",
    "Saya ingin terus mengeksplorasi dunia kreatif, komunikasi, kepemimpinan, dan gerakan kepemudaan — lalu menggabungkannya menjadi sesuatu yang dapat memberi pengaruh positif bagi orang lain.",
    "Saya ingin menggunakan media untuk mengedukasi, panggung untuk menyuarakan, kreativitas untuk menggerakkan, dan pengalaman untuk menginspirasi.",
  ],
  statement: ["CREATE WITH PURPOSE.", "CONNECT WITH PEOPLE.", "LEAVE AN IMPACT."],
  next: {
    title: "WHAT'S NEXT?",
    areas: ["Creative Industry", "Content & Media", "Public Speaking", "Youth Development", "Leadership", "Social Impact"],
    closing: "Perjalanan saya belum selesai. Justru, ini baru mulai.",
  },
};

// ------------------------------------------------------------
// ACHIEVEMENTS
// ------------------------------------------------------------
export const MILESTONES = [
  { icon: "BookOpen", group: "ACADEMIC", title: "Rank 1 Consistently", detail: "Dipertahankan dari Grade 10 hingga Grade 12 (in progress)" },
  { icon: "GraduationCap", group: "ACADEMIC", title: "Best Graduate", detail: "Lulus sebagai salah satu siswa terbaik di SMP" },
  { icon: "TrafficCone", group: "DUTA & YOUTH", title: "Duta Lalu Lintas 2025", detail: "Polres Tangerang Selatan" },
  { icon: "Medal", group: "DUTA & YOUTH", title: "Finalist Mandala Jaya 2025", detail: "Duta Lalu Lintas Mandala Jaya" },
  { icon: "Globe", group: "DUTA & YOUTH", title: "Best Cultural Ambassador", detail: "Pelajar SDGs Batch 4" },
  { icon: "Palette", group: "DUTA & YOUTH", title: "Anggota Terkreatif Putra", detail: "PAB Banten" },
  { icon: "Users", group: "LEADERSHIP", title: "Chairperson PIK-R SMILEIO", detail: "Generasi pertama aktif — SMAN 10 Tangsel" },
  { icon: "PenLine", group: "LEADERSHIP", title: "Secretary of OSIS", detail: "Dua periode — SMAN 10 Tangsel" },
  { icon: "Flag", group: "LEADERSHIP", title: "Secretary of Paskibra", detail: "SMAN 10 Tangsel" },
  { icon: "Radio", group: "LEADERSHIP", title: "Media & Communication", detail: "Forum GenRe Kecamatan Ciputat" },
  { icon: "Handshake", group: "OTHER", title: "External Committee", detail: "Pelajar SDGs Batch 5" },
  { icon: "Heart", group: "OTHER", title: "Volunteer", detail: "YouCanWeShare" },
  { icon: "Trees", group: "OTHER", title: "National Forest Leadership Forum", detail: "Participant — Best Team" },
  { icon: "MessagesSquare", group: "OTHER", title: "Envirocrime Dialogue", detail: "FGD & Debate — Universitas Budi Luhur" },
  { icon: "Vote", group: "OTHER", title: "Sekolah Jawara Demokrasi", detail: "Sosialisasi Pendidikan Pemilih — KPU Kota Tangerang Selatan" },
  { icon: "Tv", group: "OTHER", title: "Metro TV Studio Visit", detail: "Media Group Network — 2026" },
];

export const SKILLS = [
  { group: "CREATIVE", items: ["Content Creation", "Video Editing", "Photo Editing", "Visual Storytelling", "Canva", "CapCut"] },
  { group: "COMMUNICATION", items: ["Public Speaking", "MC", "Social Media Communication", "Presentation", "Campaign Communication"] },
  { group: "LEADERSHIP", items: ["Organization Management", "Team Coordination", "Event Support", "Project Development"] },
  { group: "DIGITAL", items: ["Microsoft Word", "Microsoft Excel", "Social Media Management"] },
];

// ------------------------------------------------------------
// ABOUT
// ------------------------------------------------------------
export const ABOUT = {
  title: "THE STORY BEHIND KIN",
  portraitPool: [
    "/media/duta/img-24.webp",
    "/media/duta/img-26.webp",
    "/media/osis/img-09.webp",
    "/media/ycws/img-16.webp",
    "/media/jawara/img-07.webp",
    "/media/sdgs/img-10.webp",
  ],
  blocks: [
    { text: "Sedari kecil, saya selalu punya rasa ingin tahu yang besar dan senang tampil. Saya suka mencoba sesuatu yang baru, mengeksplor banyak hal, dan membagikan apa yang saya temukan." },
    { text: "Dulu saya belum tahu ke mana semua itu akan membawa saya.", italic: true },
    { big: "UNTIL I STARTED CREATING." },
    { text: "Saat pandemi membuat dunia terasa lebih dekat melalui layar, saya mulai mengeksplorasi dunia digital dan belajar membuat konten. Itu menjadi salah satu titik balik dalam hidup saya." },
    { text: "Setelah itu saya fokus pada akademik dan lulus sebagai salah satu siswa terbaik di SMP. Memasuki SMA, saya mulai mengeksplorasi aktivitas positif di luar akademik: organisasi, komunitas pemuda, public speaking, content creation, volunteering, kepemimpinan, kompetisi, dan inisiatif sosial." },
  ],
  closing: "The journey was never about finding one perfect identity. It was about exploring enough things to discover what kind of person I want to become.",
  finalLine: "I want to be someone whose presence leaves something positive behind.",
  brand: "I don't want to be remembered only for what I achieved, but for what I made possible.",
};

export const VALUES = [
  { key: "CURIOSITY", line: "Keep exploring." },
  { key: "COURAGE", line: "Be willing to step forward." },
  { key: "CONNECTION", line: "People grow through people." },
  { key: "CREATIVITY", line: "Turn ideas into something people can experience." },
  { key: "IMPACT", line: "Leave something better than you found it." },
  { key: "GROWTH", line: "Every experience becomes part of the process." },
];

export const RANDOM_FACTS = [
  "I can spend hours editing one piece of content until it feels right.",
  "I genuinely enjoy being on stage.",
  "I learn a lot by simply saying \"yes\" to new experiences.",
  "I like turning ordinary moments into content.",
  "I believe confidence grows when you finally find something worth being proud of.",
  "I am still figuring things out — and that's okay.",
];

// ------------------------------------------------------------
// JOURNAL — tambah entry baru di awal array.
// coverPool: array foto yang berganti otomatis tiap beberapa detik.
// body: array paragraf.
// ------------------------------------------------------------
export const JOURNAL = [
  {
    slug: "menghidupkan-pikr",
    title: "Menghidupkan PIK-R yang Sempat Berhenti",
    date: "2026",
    category: "LEADERSHIP",
    excerpt: "PIK-R di sekolah kami sempat tidak aktif. Ini cerita bagaimana kami menghidupkannya kembali — dan kenapa SMILE TALK lahir dari obrolan sederhana.",
    coverPool: ["/media/smileio/img-13.webp", "/media/smileio/img-11.webp", "/media/smileio/img-21.webp", "/media/smileio/img-05.webp"],
    body: [
      "Waktu pertama kali dengar soal PIK-R di sekolah, kondisinya sudah tidak aktif. Tidak ada kegiatan, tidak ada konten, tidak ada yang benar-benar tahu PIK-R itu ngapain. Gampang banget sebenarnya untuk bilang \"ya udah, emang gitu\" — tapi rasanya sayang kalau ruang sepotensial itu dibiarkan mati.",
      "Bersama generasi pertama yang aktif, kami mulai dari hal yang paling basic: membuat PIK-R terasa ada lagi. Menyusun kegiatan, membangun komunikasi yang dekat dengan keseharian remaja, dan pelan-pelan mengisi media sosialnya dengan konten edukasi.",
      "Dari situ lahir SMILE TALK. Idenya sederhana: remaja lebih nyaman bercerita lewat ruang yang familiar. Jadi kenapa counselor booking tidak lewat media sosial saja? Bukan teknologi yang rumit — tapi pendekatan yang lebih dekat.",
      "Yang paling saya pelajari: leadership tidak selalu soal memimpin sesuatu yang sudah berjalan. Kadang leadership justru tentang menghidupkan kembali sesuatu yang sempat berhenti — dan itu jauh lebih menantang, tapi juga jauh lebih berkesan.",
    ],
  },
  {
    slug: "dua-periode-di-balik-layar",
    title: "Dua Periode di Balik Layar",
    date: "2025",
    category: "BEHIND THE SCENES",
    excerpt: "Dua periode jadi sekretaris OSIS mengajarkan saya bahwa tidak semua leadership terlihat di panggung. Sebagian justru terjadi di spreadsheet, rundown, dan chat koordinasi tengah malam.",
    coverPool: ["/media/osis/img-09.webp", "/media/osis/img-01.webp", "/media/osis/img-05.webp", "/media/osis/img-11.webp"],
    body: [
      "Kalau ditanya bagian paling berkesan dari OSIS, jawaban saya mungkin membosankan buat sebagian orang: administrasi. Surat, notulen, rundown, koordinasi antar-bidang. Hal-hal yang tidak pernah muncul di foto dokumentasi.",
      "Tapi justru di situlah saya belajar. Event yang terlihat mulus di hari-H biasanya ditentukan oleh hal-hal kecil yang dibereskan jauh sebelumnya. Satu rundown yang rapi bisa menyelamatkan satu acara. Satu koordinasi yang telat bisa merusaknya.",
      "Di periode pertama, saya belajar sistemnya. Di periode kedua, saya belajar memperbaikinya. Dua periode di posisi yang sama ternyata tidak pernah terasa sama.",
      "Sekretaris mengajarkan saya bahwa leadership tidak selalu berarti berdiri paling depan. Kadang, leadership berarti memastikan semuanya tetap berjalan — meskipun tidak ada yang tahu kamu yang menjalankannya.",
    ],
  },
  {
    slug: "dari-peserta-jadi-panitia",
    title: "Dari Peserta Jadi Panitia",
    date: "2026",
    category: "GROWTH",
    excerpt: "Di Batch 4 saya datang untuk belajar. Di Batch 5 saya kembali untuk berkontribusi. Dua pengalaman di ruang yang sama, dengan posisi — dan cara pandang — yang berbeda.",
    coverPool: ["/media/sdgs/img-10.webp", "/media/sdgs/img-08.webp", "/media/sdgs/img-02.webp", "/media/sdgs/img-16.webp"],
    body: [
      "Forum Pelajar SDGs Batch 4 adalah ruang pertama yang membuat saya sadar bahwa isu global seperti SDGs sebenarnya punya wajah lokal. Menjadi Best Cultural Ambassador di batch itu adalah bonus — yang utama adalah cara berpikirnya yang berubah.",
      "Makanya di Batch 5 saya memutuskan kembali, tapi kali ini sebagai External Committee. Rasanya beda sekali: kalau dulu saya bertanya \"apa yang bisa saya dapat?\", sekarang pertanyaannya berubah jadi \"apa yang bisa saya beri?\"",
      "Menjadi panitia membuat saya melihat sisi lain dari sebuah program: bagaimana sebuah rangkaian kegiatan dirancang, bagaimana peserta dijaga pengalamannya, dan bagaimana sebuah komunitas dirawat supaya terus hidup.",
      "Pelajarannya sederhana: kontribusi terbaik sering dimulai dari kesediaan untuk belajar dulu — lalu kerendahan hati untuk kembali dan membantu.",
    ],
  },
  {
    slug: "internet-adalah-kelas-pertamaku",
    title: "Internet Adalah Kelas Pertamaku",
    date: "",
    category: "REFLECTION",
    excerpt: "Semua bermuara ke satu titik: masa pandemi, sebuah layar, dan rasa penasaran yang tidak pernah benar-benar berhenti.",
    coverPool: ["/media/pab/img-02.webp", "/media/jawara/img-07.webp", "/media/metrotv/img-09.webp", "/media/ycws/img-16.webp"],
    body: [
      "Saya tidak belajar editing dari sekolah formal. Saya belajar dari trial and error, tutorial acak, dan kebiasaan mengutak-atik satu konten berjam-jam sampai rasanya \"pas\". Internet, dalam banyak hal, adalah kelas pertama saya.",
      "Yang menarik: skill yang awalnya cuma iseng itu ternyata jadi berguna di mana-mana. Di PIK-R untuk konten edukasi. Di PAB untuk kampanye anti-bullying. Di GenRe untuk media dan komunikasi. Satu skill, banyak medan.",
      "Saya juga belajar bahwa karya yang baik jarang lahir di versi pertama. Yang terlihat selesai biasanya punya banyak versi sebelumnya — dan tidak apa-apa.",
      "Sampai sekarang saya masih merasa sedang belajar. Tapi mungkin memang itu intinya: kreativitas bukan tujuan akhir, melainkan kebiasaan untuk terus mencoba.",
    ],
  },
];

// ------------------------------------------------------------
// CONTACT / FINAL
// ------------------------------------------------------------
export const CONTACT = {
  title: "LET'S MAKE SOMETHING MEANINGFUL.",
  copy: "Punya ide, project, campaign, event, creative collaboration, atau sekadar ingin ngobrol tentang sesuatu yang bisa kita kerjakan bersama?",
  business: "Punya project yang membutuhkan creative thinking, content, communication, youth perspective, atau seseorang yang bisa membantu membawa ide ke audiens?",
  openTo: ["Creative Collaboration", "Youth Projects", "Social Campaigns", "Content Creation", "Events", "Public Speaking", "Media & Communication", "Business Inquiries"],
  finalTitle: "THIS IS ONLY THE BEGINNING.",
  finalText: "Saya belum tahu persis akan menjadi siapa saya beberapa tahun dari sekarang. Tapi saya tahu saya ingin terus mengeksplorasi, terus menciptakan, terus bertemu orang-orang baru, dan menggunakan apa yang saya punya untuk memberi pengaruh positif. Karena mungkin, perjalanan bukan tentang menemukan satu versi diri yang sempurna. Mungkin perjalanan adalah tentang terus menjadi.",
  finalQuestion: "SO, WHAT CAN WE CREATE NEXT?",
  finalSub: "Saya masih terus mengeksplorasi, belajar, dan menciptakan sesuatu yang baru. Kalau kamu punya ide, project, campaign, event, atau collaboration yang ingin dikembangkan bersama — let's talk.",
};

export const NAV_PAGES = [
  { no: "01", label: "HOME", to: "/" },
  { no: "02", label: "ABOUT", to: "/about" },
  { no: "03", label: "EXPERIENCES", to: "/experiences" },
  { no: "04", label: "CREATIVE", to: "/creative" },
  { no: "05", label: "IMPACT", to: "/impact" },
  { no: "06", label: "ACHIEVEMENTS", to: "/achievements" },
  { no: "07", label: "JOURNAL", to: "/journal" },
  { no: "08", label: "CONTACT", to: "/contact" },
];
